module.exports = __webpack_public_path__ + "img/SuperOK-hero-2.8031ebdd.png";